<template>
  <NotificationBanner
    status="warning"
    :dismissible="false"
    :should-show="isNotificationBannerVisible"
    :should-show-icon="false"
    :font-size-class="'text-sm'"
  >
    {{ $t('Volume discounts cannot be combined with discount codes.') }}
  </NotificationBanner>
</template>
<script lang="ts">

import checkIfVolumeDiscountIsActiveForAnyItem from
  '~~/helpers/Checkout/checkIfVolumeDiscountIsActiveForAnyItem/checkIfVolumeDiscountIsActiveForAnyItem';
export default defineComponent({
  name: 'CartDiscountWarning',

  setup() {

    const { isDiscountConflict } = useVolumeDiscountsStore();
    const { lineItems } = useLineItems();

    const isVolumeDiscountActiveForAnyItem = computed(() => checkIfVolumeDiscountIsActiveForAnyItem(lineItems.value));

    const isNotificationBannerVisible = computed(() => {

      return isDiscountConflict.value && isVolumeDiscountActiveForAnyItem.value;
    
    });

    return {
      isDiscountConflict,
      isVolumeDiscountActiveForAnyItem,
      isNotificationBannerVisible,
    };
  
  },
});

</script>
